import { useMemo, useRef } from 'react';

const useActiveNavState = (initialNavState, active) => {
  const initialStateRef = useRef(initialNavState);

  return useMemo(() => initialStateRef.current.map((item) => ({
    ...item,
    isSelected: !!active && active.indexOf(item.path) > -1,
  })), [active]);
};

export default useActiveNavState;
